import _ from 'lodash'

/**
 * Returns a new array with any nil or empty string values removed from the
 * given array. Does not mutate the given array
 *
 * @param {Array} arr the array to trim
 *
 * @return {Array} a new trimmed array
 */
function trimArray (arr) {
	return _.filter(arr, v => {
		if (_.isNil(v)) {
			return false
		}

		if (_.isString(v) && v.trim().length === 0) {
			return false
		}

		return true
	})
}

export default trimArray

trimArray.__filename__ = 'components/trim-array.js'
